import { differenceInSeconds, parseJSON } from 'date-fns'

// Allowed notification channels
export const ALLOWED_CHANNELS = {
  ANDROID: 'android',
  IOS: 'ios',
  SMS: 'sms',
  PHONE: 'phone',
}

/**
 * Checks if a patrol is delayed - whether status has been running too long
 * @param {Object} patrol - patrol object
 * @returns {boolean} - true if patrol is delayed (status running too long)
 */
export function isPatrolDelayed(patrol) {
  if (!patrol?.tasks?.length) {
    return false
  }

  // Find active task
  let task = null
  for (const t of patrol.tasks) {
    if (isOnTheTask(t)) {
      task = t
      break
    }
  }

  if (!task) {
    task = patrol.tasks[0]
  }

  const status = task?.details?.status
  if (!status) {
    return false
  }

  const alertTime = Labels.get(status.label_id).alertTime
  if (!alertTime) {
    return false
  }

  const age = (Date.now() - parseJSON(status.created_at)) / 1000
  return age > alertTime
}

export const UserTaskType = {
  DISPATCHER: 1,
  PATROL: 2,
  SERVICE: 3,
}

export const CommentsDict = [
  'Osoby opuściły obiekt',
  'Braki zasilania w rejonie',
  'Próba systemu alarmowego',
  'Na chwilę',
  'Oddzwoni',
  'Opuścił lokal przed przyjazdem patrolu',
  'Tylko powiadamianie',
  'Nie zna hasła',
  'Ma tak zostać',
  'Powiadomiono serwis Security',
  'Przystawka GSM własnością klienta',
  'Alarm przy uzbrajaniu',
  'Opuściiły lokal przed przyjazdem patrolu',
  'Sprawca oddalił się przed przybyciem patrolu',
  'Weryfikacja wizyjna',
  'Zmiana adresu',
  'Sprawdzi później',
  'Sprawdził',
  'Moduł GSM w centrali',
  'Normalna praca',
  'Kot w domu',
  'Odwołano przed dojazdem patrolu',
  'Wyładowany akumulator',
  'Oddalil się przed przybyciem patrolu',
  'Przyjedzie na miejsce',
  'Prosi o serwis Security',
  'Patrol zapoznał się z obiektem',
  'System p. pożarowy',
  'Pracownik w obiekcie',
  'Silny wiatr',
  'Prace remontowe',
  'Brak uwag',
  'Brak zasilania sieciowego',
  'Pouczony opuścił lokal',
  'Kontrola obowiązkowa obiektu przez patrol',
  'Powiadomiono o możliwości braku monitorowania',
  'Przyjedzie na miejsce i sprawdzi',
  'Wchodzi na 15 minut',
  'Rozbrojenie po alarmie',
  'Zatrzymany sprawca kradzieży',
  'Powiadomiono KP2',
  'Opuścił obiekt po przyjeździe patrolu',
  'Niski stan zasilania awaryjnego',
  'Nie wysyłać patrolu',
  'Tak ma pozostać do jutra',
  'Potwierdzono z dokumentu tożsamości',
  'Pracownicy na budowie',
  'Nie reagować do odwołania telefonicznego',
  'Otwarte drzwi balkonowe',
  'Prosi o interwencję patrolu',
  'Odwołanie po przyjeździe patrolu',
  'P190; brak klucza',
  'Słaba widoczność obiektu z kamer',
  'Nie reagować na alarmy',
  'Prosi o podjazd',
  'Kontrola zza ogrodzenia',
  'Nie użyto pilota',
  'Do uzbrojenia',
  'Problem z zasiegiem',
  'Sprawdzono obiekt wewnątrz',
  'Wcześniejsze wejście',
  'Nie nasz system',
  'Powiadomiono Policję',
  'Prośba o serwis',
  'Uchylone okno',
  'Wejście pracownika SNG',
  'Koty na terenie',
  'Powiadomiony o braku możliwości monitorowania',
  'Uchylone okna',
  'Nadal',
  'Wysłać patrol',
  'Nie będzie uzbrojenia',
  'Próba wejścia do hostelu',
  'Karta własnością klienta',
  'System p-poż',
  'Kilkanaście minut',
  'Powrót linii telefonicznej',
  'Sprzątaczka',
  'Do zgłoszenia telefonicznego',
  'Tylko pilot napadowy',
  'Brak komunikatu po linii telefonicznej',
  'Pracownicy w obiekcie',
  'Z powodu zadłużenia',
  'Kontrola obiektu przez patrol',
  'Odwołane przed dojazdem patrolu',
  'Brak uzbrojenia po telefonie',
  'Tylko radio',
  'Sprawdzi',
  'Wielokrotne rozbrojenia w ciągu dnia',
  'Potwierdza',
  'Prace elektryczne',
  'Osoby na terenie obiektu',
  'Asysta patrolu',
  'Powrót',
  'System uzbrojony',
  'Szkolenie pracownika',
  'Próba systemu',
  'Powrót zasilania',
  'Potwierdzono odwołanie w PSP',
  'Opuściły obiekt przed przyjazdem patrolu',
  'Tak może pozostać',
  'Patrol dojechał przed odwołaniem',
  'Oddalili się przed przybyciem patrolu',
  'Sprawdzono zza ogrodzenia',
  'Do oddzwonienia',
  'Kontrola rutynowa obiektu przez patrol',
  'Służba bez uwag',
  'Demontaż systemu',
  'Weryfikacja OWSN',
  'Powrót obrazu z kamer',
  'Powiadomiono KP Wrzeszcz',
  'Na kilkanaście minut',
  'Uchylone okno nad wejściem',
  'Oddalił się przed przybyciem patrolu',
  'Powiadomiona o braku możliwości monitorowania',
  'Brak obrazu z kamer',
  'Powiadomiono KP Stogi',
  'Powiadomiono PSP',
  'Próbny alarm',
  'GSM i SIM klienta',
  'Odwoł',
  'Pęknięta szyba w oknie',
  'Potwierdzono zgłoszenie w PSP',
  'Powiadomiono o braku możliwości monitorowania',
  'Prosi o kontakt serwis Security',
  'Brak możliwości monitorowania',
  'Nie będzie uzbrojenia do rana',
  'Wcześniejsza praca',
  'Odwołano po przyjeździe patrolu',
  'Powiadomiono o braku zasilania sieciowego',
  'Telefoniczne zgłoszenie',
  'Opuściły lokal przed przyjazdem patrolu',
  'Uchylone okno balkonowe',
  'Mają oddzwonić',
  'Brak transmisji testowej GSM',
  'Sam sprawdzi',
  'Uzbroił zdalnie',
  'Otwarte drzwi wejściowe',
  'Agresywny i pijany klient',
  'Sprzątaczka na miejscu',
  'Możliwe rozbrojenia w ciągu dnia',
  'Kilka minut dłużej',
  'Odwołanie przed przyjazdem patrolu',
  'Moduł GSM własnością klienta',
  'Demontaż nadajnika gsm',
  'Prace serwisowe',
  'Problem z systemem',
  'Nie reagować na pierwszy alarm',
  'Wyjaśni',
  'Patrol na miejscu',
  'Zgłoszono serwisowi Security',
  'Karta i GSM własnością klienta',
  'Nie dozwolone rozbrojenie',
  'Bariera zewnętrzna',
  'Własność klienta',
  'Nie reagować do odwołania',
  'Prośba o podjazd',
  'Wsparcie ochrony fizycznej SECURITY',
  'Brak klucza',
  'Po spłacie zadłużenia',
  'Sprawdzi i oddzwoni',
  'Powrót zasilania sieciowego',
  'Otwarta brama wjazdowa',
  'Prace serwisowe Security',
  'Odwołała',
  'Ujęty sprawca kradzieży',
  'Oddzwoniła',
  'Praca całodobowa',
  'Tylko telefon',
  'Niezamknięta brama',
  'Brak uwag po zapoznaniu się z obiektem',
  'Pracownik SNG',
  'Osoba na terenie obiektu',
  'Brak możliwości spawdzenia',
  'Oddaliła się przed przybyciem patrolu',
  'Sprawca oddalił się z miejsca zdarzenia',
  'Do odwołania telefonicznego',
  'Komunikat doszedł do patrolu',
  'Otwarte drzwi',
  'Na kilka minut',
  'Normalny ruch',
  'Kontrola czasu dojazdu',
  'Tak ma pozostać',
  'Wejście pracownika',
  'Wezwano Policję',
  'Brak uwag po kontroli obiektu',
  'Błąd obsługi',
  'Alarm fałszywy',
  'Problem z uzbrojeniem',
  'Potwierdza w PSP',
  'Prace remontowo-budowlane',
  'Długi brak łączności telefonicznej',
  'Brak widocznych śladów włamania',
]

export class UserTask {
  iconName(taskType) {
    switch (taskType) {
      case 'dispatcher':
      case UserTaskType.DISPATCHER:
        return 'mdi-account-tie'
      case 'patrol':
      case UserTaskType.PATROL:
        return 'mdi-car-emergency'
      case 'service':
      case UserTaskType.SERVICE:
        return 'mdi-cog-outline'
    }
  }

  /**
   * Check if task is read-only (cannot be edited)
   * Uses task.permissions.read_only from backend and checks editable_until time
   * @param {Object} task - task object
   * @param {number} marginMinutes - safety margin in minutes (default 2)
   * @returns {boolean} - true if task is read-only
   */
  isReadOnly(task, marginMinutes = 2) {
    if (task == null) {
      return true
    }

    // Backend manages all logic through permissions
    if (!task?.permissions) {
      return true // No permissions = readonly by default
    }

    // If explicitly read_only, can't edit
    if (task.permissions.read_only === true) {
      return true
    }

    // Check if editable_until time has passed (with margin)
    const editableUntil = getEditableUntil(task)
    if (editableUntil) {
      const now = new Date()
      const marginMs = marginMinutes * 60 * 1000
      if (now.getTime() >= (editableUntil.getTime() - marginMs)) {
        return true // Time expired, can't edit anymore
      }
    }

    // read_only is false and time is valid (or no time restriction)
    return false
  }

  allTypes() {
    return UserTaskType
  }

  isFinished(task) {
    if (isClosed(task)) return true
    if (!task.details) return false
    if (!task.details.history) return false
    for (const index in task.details.history) {
      if (task.details.history[index].stage == 'Zakończone') {
        return true
      }
    }
    return false
  }

  duration(task) {
    if (!task?.created_at) {
      return null
    }
    const start = parseJSON(task.created_at)
    let end = new Date()
    if (task.closed_at) {
      end = parseJSON(task.closed_at)
    }
    return differenceInSeconds(end, start)
  }

  // Method for getting label description in context (similar to Swift descriptionInContext)
  getDescriptionInContext(labelId, taskType) {
    return Labels.descriptionInContext(labelId, taskType)
  }

  // Method for getting label description for dispatcher (similar to Swift descriptionForDispatcher)
  getDescriptionForDispatcher(labelId) {
    return Labels.descriptionForDispatcher(labelId)
  }

  // Method for getting label description for patrol (similar to Swift descriptionForPatrol)
  getDescriptionForPatrol(labelId) {
    return Labels.descriptionForPatrol(labelId)
  }
}

const userTaskInstance = new UserTask()
export default userTaskInstance

export function isPatrol(task) {
  return task?.task_type == UserTaskType.PATROL ?? false
}
export function isWaitingForPermission(task) {
  return (
    (task?.details?.status?.progress == 99 ?? false) &&
    (!task?.details?.options?.can_closed ?? false)
  )
}

export function isClosed(task) {
  return task?.closed_at != null ?? false
}

export function isRootTask(task) {
  return task?.parent == null ?? false
}

/**
 * Get the reason why task is read-only from permissions
 * @param {Object} task - task object
 * @returns {string|null} - reason string or null if not read-only
 */
export function getReadOnlyReason(task) {
  return task?.permissions?.reason ?? null
}

/**
 * Check if a specific field can be edited based on task permissions
 * Backend provides editable_fields array for granular control
 * @param {Object} task - task object
 * @param {string} fieldName - name of the field to check (e.g., "cost", "status", "comment")
 * @returns {boolean} - true if field can be edited
 */
export function canEditField(task, fieldName) {
  // If no permissions, assume editable (fallback to old behavior)
  if (!task?.permissions) {
    return !isClosed(task)
  }

  // If read_only is false, all fields are editable
  if (task.permissions.read_only === false) {
    return true
  }

  // If read_only is true, check editable_fields array
  const editableFields = task.permissions.editable_fields || []
  return editableFields.includes(fieldName)
}

/**
 * Get list of editable fields from task permissions
 * @param {Object} task - task object
 * @returns {Array<string>} - array of editable field names (e.g., ["cost", "statistics", "status"])
 */
export function getEditableFields(task) {
  return task?.permissions?.editable_fields || []
}

/**
 * Get the date until which task can be edited
 * Backend sets this based on 8h window or other rules
 * @param {Object} task - task object
 * @returns {Date|null} - date until editable or null if not set
 */
export function getEditableUntil(task) {
  if (!task?.permissions?.editable_until) {
    return null
  }
  return parseJSON(task.permissions.editable_until)
}

/**
 * Check if task is currently editable based on editable_until date
 * @param {Object} task - task object
 * @param {number} marginMinutes - safety margin in minutes (default 2)
 * @returns {boolean} - true if current time is before editable_until (with margin)
 */
export function isEditableNow(task, marginMinutes = 2) {
  const editableUntil = getEditableUntil(task)
  if (!editableUntil) {
    // If no editable_until, check read_only flag
    return !task?.permissions?.read_only
  }
  // Add safety margin to avoid edge cases
  const now = new Date()
  const marginMs = marginMinutes * 60 * 1000
  return now.getTime() < (editableUntil.getTime() - marginMs)
}

/**
 * Core validation for field editability
 * Checks: 1) read_only flag, 2) editable_until time with margin, 3) field in editable_fields
 * @param {Object} task - task object
 * @param {string} fieldName - name of the field to check
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if field can be edited
 */
function canEditFieldCore(task, fieldName, marginMinutes = 2) {
  // No permissions = fallback to old behavior
  if (!task?.permissions) {
    return !isClosed(task)
  }

  // If read_only is true, can't edit anything
  if (task.permissions.read_only === true) {
    return false
  }

  // Check time constraint with margin
  const editableUntil = getEditableUntil(task)
  if (editableUntil) {
    const now = new Date()
    const marginMs = marginMinutes * 60 * 1000
    if (now.getTime() >= (editableUntil.getTime() - marginMs)) {
      return false
    }
  }

  // If read_only is false and time is valid, check if field is in editable_fields
  const editableFields = task.permissions.editable_fields || []
  return editableFields.includes(fieldName)
}

/**
 * Check if cost field can be edited
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if cost can be edited
 */
export function canEditCost(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'cost', marginMinutes)
}

/**
 * Check if statistics field can be edited
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if statistics can be edited
 */
export function canEditStatistics(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'statistics', marginMinutes)
}

/**
 * Check if user can add new status entry to task
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if status can be added
 */
export function canAddStatus(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'add_status', marginMinutes)
}

/**
 * Check if user can add comment to task
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if comment can be added
 */
export function canAddComment(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'add_comment', marginMinutes)
}

/**
 * Check if user can mark task as read
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if task can be marked as read
 */
export function canMarkRead(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'mark_read', marginMinutes)
}

/**
 * Check if user can edit an existing status entry in task history.
 * Backend controls this via 'edit_status_entry' in editable_fields.
 * @param {Object} task - task object
 * @param {number} marginMinutes - time margin in minutes (default 2)
 * @returns {boolean} - true if status entries can be edited
 */
export function canEditStatusEntry(task, marginMinutes = 2) {
  return canEditFieldCore(task, 'edit_status_entry', marginMinutes)
}


export async function closeTask({
  context,
  dialogComponent,
  event,
  task,
  taskService,
  siteService,
}) {
  const result = await context.$dialog.show(dialogComponent, {
    event: event,
    waitForResult: true,
    width: 900,
    actions: {
      false: 'Anuluj',
      true: {
        color: 'success',
        text: 'OK',
      },
    },
  })
  if (result === false || result === undefined) {
    return
  }
  // Validate required data
  if (!event?.site?.id || !task?.id) {
    console.error('Missing required data for closeTask:', { event, task })
    throw new Error('Cannot close task: missing event.site.id or task.id')
  }

  // Process payment updates
  var promises = result.payments
    .filter(payment => payment.updated)
    .map(payment => {
      // Update task cost with payment token
      return taskService.setCost(event.site.id, payment.task.id, payment.token)
    })
  if (result.note) {
    let note = {
      siteId: event.site.id,
      category: result.note.id,
      beginningAt: new Date(task.created_at),
      expiresAt: result.note.expiresAt ? new Date(result.note.expiresAt) : null,
      message: result.message,
      reportedBy: null,
    }
    promises.push(siteService.createNote(note))
  }
  Promise.all(promises).then(() => {
    return taskService.closeTask(event.site.id, task.id, result.message, result.comment)
  })
}

export async function setPaymentDialog(context, dialogComponent, taskService, tasks, site) {
  let costs = tasks.map(t => {
    return {
      taskId: t.id,
      task: t,
      user: firstAssigneeUser(t),
      token: {
        value: t.details?.cost?.token ?? 0,
        name: t.details?.cost?.name ?? '',
      },
      readonly: !canEditCost(t)
    }
  })

  const dialogInstance = await context.$dialog.show(dialogComponent, {
    costs: costs,
    site: site,
  })
  dialogInstance.waitForResult = true
  return dialogInstance.wait().then(results => {
    if (!results) return []
    const promises = results
      .filter(element => element.updated)
      .map(element => {
        return taskService
          .setCost(site.id, element.taskId, element.newToken)
          .then(response => response.data)
      })

    return Promise.all(promises)
  })
}

/**
 * Show dialog to notify users about a task
 * @param {Object} params - Function parameters
 * @param {Object} params.context - Vue component context
 * @param {Component} params.notifyDialog - Dialog component to show
 * @param {Object} params.siteService - Site service instance
 * @param {Object} params.taskService - Task service instance
 * @param {Object} params.event - Event object
 * @param {Object} params.task - Task object
 * @returns {Promise} Promise that resolves when notification is sent
 */
export async function notifyUsersDialog({
  context,
  notifyDialog,
  siteService,
  taskService,
  event,
  task,
}) {
  const dialogInstance = await context.$dialog.show(notifyDialog, {
    subtitle: context.$options.filters.siteFullName(event.site),
    users: new Promise(resolve => {
      siteService
        .fetchMembers(event.site.id)
        .then(result => resolve(result.map(member => member.user)))
      // .then(result => resolve(result.filter(user => notifiedUsers.find(u => u.id == user.id) == null)))
    }),
    usersSelected: [],
  })
  dialogInstance.waitForResult = true
  await dialogInstance.wait().then(user => {
    if (!user) return //user can be 'false' when dialog is canceled
    if (!task.details.notified) {
      task.details.notified = []
    }
    const existingUser = task.details.notified.find(u => u.id == user.id)
    if (existingUser?.channels?.includes(ALLOWED_CHANNELS.PHONE)) {
      return
    }
    // var notified = task.details.notified
    // notified.push({id: user.id, name: this.$options.filters.userName(user)})
    return taskService.putNotifiedUser(event.site.id, task.id, user, ALLOWED_CHANNELS.PHONE)
  })
}

export async function foundUsersDialog({
  context,
  foundDialog,
  siteService,
  taskService,
  site,
  task,
}) {
  const dialogInstance = await context.$dialog.show(foundDialog, {
    title: 'Osoba w obiekcie',
    subtitle: context.$options.filters.siteFullName(site),
    users: new Promise(resolve => {
      siteService.fetchMembers(site.id).then(result => resolve(result.map(member => member.user)))
      // .then(result => resolve(result.filter(user => notifiedUsers.find(u => u.id == user.id) == null)))
    }),
    usersSelected: [],
  })
  dialogInstance.waitForResult = true
  return dialogInstance.wait().then(user => {
    if (!user) return //user can be 'false' when dialog is canceled
    if (!task.details.found) {
      task.details.found = []
    }
    if (task.details.found.find(u => u.id == user.id)) {
      return
    }
    // var notified = task.details.notified
    // notified.push({id: user.id, name: this.$options.filters.userName(user)})
    return taskService.putFoundUser(site.id, task.id, user)
  })
}

export async function cancelTask({
  context,
  cancelTaskDialog,
  siteService,
  taskService,
  event,
  task,
}) {
  const dialogInstance = await context.$dialog.show(cancelTaskDialog, {
    cancelPassword: event?.site?.password,
    users: new Promise(resolve => {
      siteService
        .fetchMembers(event.site.id)
        .then(result => resolve(result.map(member => member.user)))
    }),
  })
  dialogInstance.waitForResult = true
  await dialogInstance.wait().then(result => {
    if (!result) {
      return
    }
    return taskService.cancelTask(event.site.id, task.id, result.comment, null, result.user)
  })
}

export async function patrolSummaryDialog(context, summaryTaskDialog, taskService, task, site) {
  const dialogInstance = await context.$dialog.show(summaryTaskDialog, {})
  dialogInstance.waitForResult = true
  return dialogInstance.wait().then(result => {
    if (!result) {
      return
    }
    return taskService.setStatus(site.id, task.id, result)
  })
}

export function taskTree(tasks) {
  if (!tasks) {
    return null
  }
  var root = tasks.find(task => {
    return task.parent == null
  })
  if (root == null) {
    return null
  }
  root.subtasks = []
  tasks.forEach(task => {
    if (task == root) {
      return
    }
    if (task.parent == root.id) {
      root.subtasks.push(task)
    }
  })
  return root
}

/**
 * Checks if a task is open
 * A task is open if it has no closed_at date
 * @param {Object} task - task object
 * @returns {boolean} - true if task is open, false if closed
 * */
export function isTaskOpen(task) {
  return task?.closed_at == null
}

export function isTaskClosed(task) {
  return !isTaskOpen(task)
}

/**
 * @param {*} tasks lists of tasks
 * @returns last modified task
 */
export function lastModifiedTask(tasks) {
  var task = tasks[tasks.length - 1]
  for (const t of tasks) {
    if (t.modified_at > task.modified_at) {
      task = t
    }
  }
  return task
}

/**
 * @param {*} tasks list of tasks
 * @returns {string|null} latest modified_at timestamp
 */
export function getTasksModifiedAt(tasks) {
  if (!tasks?.length) {
    return null
  }
  return lastModifiedTask(tasks).modified_at
}

/**
 * @param {*} event event object
 * @returns {string|null} latest task modification timestamp for event
 */
export function getEventTaskModifiedAt(event) {
  return event?.task_modified_at || getTasksModifiedAt(event?.tasks) || event?.modified_at || null
}

/**
 * @param {*} tasks lists of tasks
 * @returns last modified task
 */
export function isOnTheTask(task) {
  let status = task.details?.status
  if (!status) {
    return false
  }
  return status.label_id == LabelId.ON_THE_WAY && !status.paused
}

export function firstAssigneeUser(task) {
  if (!task?.assignees?.length) {
    return null
  }
  return task.assignees[0].user
}

/**
 * Resolve task owner from task_owner field or fallback to first assignee
 * @param {Object} task - obiekt task
 * @returns {Object|null} user object (task_owner or first assignee) or null
 */
export function resolveTaskOwner(task) {
  return task?.task_owner || firstAssigneeUser(task) || null;
}

export function getPrimaryEventTask(tasks) {
  if (!tasks?.length) {
    return null;
  }

  return tasks.find(task => task.task_type === UserTaskType.DISPATCHER && !task.closed_at)
    || tasks.find(task => task.task_type === UserTaskType.SERVICE && !task.closed_at)
    || tasks.find(task => task.task_type === UserTaskType.DISPATCHER)
    || tasks.find(task => task.task_type === UserTaskType.SERVICE)
    || (tasks.length === 1 ? tasks[0] : null);
}

/**
 * Sprawdza czy użytkownik o podanym userId jest przypisany do tasku
 * @param {Object} task - obiekt task
 * @param {string|number} userId - id użytkownika
 * @returns {boolean} true jeśli przypisany, false jeśli nie
 */
export function isUserAssignedToTask(task, userId) {
  if (!task || !task.assignees) return false;
  return task.assignees.some(a => a.user.id === userId);
}

export const LabelId = {
  NEW: 0,
  DELIVERED: 10,
  READ: 20,
  ON_THE_WAY: 30,
  AT_LOCATION: 50,
  CANCELED: 70,
  PAUSED: 80,
  RESUMED: 81,
  POSITIVE: 100,
  NEGATIVE: 101,
  DONE: 102,
  PROBLEMS: 110,
  END_OF_PROBLEMS: 111,
  BUSY: 130,
  IDLE: 131,
  NOTIFICATION: 200,
  COMMENT: 300,
  CLOSE: 1000,
}

export class Labels {
  static get(id) {
    return this.all().find(item => item.id == id)
  }

  static isFinal(id) {
    return (
      id == LabelId.DONE ||
      id == LabelId.CANCELED ||
      id == LabelId.POSITIVE ||
      id == LabelId.NEGATIVE
    )
  }

  static all() {
    return [
      {
        id: LabelId.NEW,
        title: 'Rozpoczęcie obsługi',
        action: 'Rozpocznij obsługę',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-send-outline',
        description: null,
        alertTime: 30,
      },
      {
        id: LabelId.DELIVERED,
        title: 'Dostarczony',
        action: 'Dostarczony',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-send-check-outline',
        description: null,
      },
      {
        id: LabelId.READ,
        title: 'Odczytany',
        action: 'Odczytany',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-send-check-outline',
        description: null,
        alertTime: 30,
      },
      {
        id: LabelId.ON_THE_WAY,
        title: 'W drodze',
        action: 'W drodze',
        color: dark => (dark ? 'blue lighten-4' : 'blue darken-4'),
        icon: 'mdi-car',
        description: null,
      },
      {
        id: LabelId.AT_LOCATION,
        title: 'Na miejscu',
        action: 'Na miejscu',
        color: dark => (dark ? 'blue lighten-4' : 'blue darken-4'),
        icon: 'mdi-map-marker',
        description: null,
      },
      {
        id: LabelId.CANCELED,
        title: 'Odwołany',
        action: 'Odwołaj',
        color: dark => (dark ? 'yellow lighten-4' : 'yellow darken-4'),
        icon: 'mdi-cancel',
        description: null,
      },
      {
        id: LabelId.PAUSED,
        title: 'Wstrzymany',
        action: 'Wstrzymaj',
        color: dark => (dark ? 'yellow lighten-4' : 'yellow darken-4'),
        icon: 'mdi-pause',
        description: null,
      },
      {
        id: LabelId.RESUMED,
        title: 'Wznowiony',
        action: 'Wznowienie',
        color: dark => (dark ? 'green lighten-4' : 'green darken-4'),
        icon: 'mdi-pause',
        description: null,
      },
      {
        id: LabelId.POSITIVE,
        title: 'Potwierdzony',
        action: 'Potwierdź',
        color: dark => (dark ? 'orange lighten-4' : 'light-green darken-4'),
        icon: 'mdi-check-circle-outline',
        description: null,
      },
      {
        id: LabelId.NEGATIVE,
        title: 'Fałszywy',
        action: 'Fałszywy',
        color: dark => (dark ? 'blue lighten-4' : 'blue darken-4'),
        icon: 'mdi-check-circle-outline',
        description: null,
      },
      {
        id: LabelId.DONE,
        title: 'Zakończony',
        action: 'Zakończ',
        color: dark => (dark ? 'grey lighten-4' : 'grey darken-4'),
        icon: 'mdi-check-circle-outline',
        description: null,
      },
      {
        id: LabelId.PROBLEMS,
        title: 'Problemy',
        action: 'Problemy',
        color: dark => (dark ? 'red lighten-4' : 'red darken-4'),
        icon: 'mdi-alert-outline',
        description: null,
      },
      {
        id: LabelId.END_OF_PROBLEMS,
        title: 'Koniec problemów',
        action: 'Koniec problemów',
        color: dark => (dark ? 'green lighten-4' : 'green darken-4'),
        icon: 'mdi-alert-outline',
        description: null,
      },
      {
        id: LabelId.BUSY,
        title: 'Zajęty',
        action: 'Zajęty',
        color: dark => (dark ? 'teal lighten-4' : 'teal lighten-4'),
        icon: 'mdi-sleep',
        description: null,
      },
      {
        id: LabelId.IDLE,
        title: 'Wolny',
        action: 'Wolny',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-sleep',
        description: null,
      },
      {
        id: LabelId.NOTIFICATION,
        title: 'Powiadomienie',
        action: 'Powiadom',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-bell-badge-outline',
        description: null,
      },
      {
        id: LabelId.PERSON,
        title: 'Osoba w obiekcie',
        action: 'Osoba w obiekcie',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-eye-outline',
        description: null,
      },
      {
        id: LabelId.COMMENT,
        title: 'Komentarz',
        action: 'Dodaj komentarz',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-comment-text-outline',
        description: null,
      },
      {
        id: LabelId.CLOSE,
        title: 'Odjazd z obiektu',
        action: 'Zamknij',
        color: dark => (dark ? 'teal lighten-4' : 'teal darken-4'),
        icon: 'mdi-check-circle-outline',
        description: null,
      },
    ]
  }

  // Helper methods for label descriptions based on task type (similar to Swift descriptionInContext)
  static descriptionForDispatcher(labelId) {
    switch (labelId) {
      case LabelId.NEW:
        return 'Rozpoczęcie obsługi' // "Start of service"
      case LabelId.CANCELED:
        return 'Odwołany' // "Canceled"
      case LabelId.POSITIVE:
      case LabelId.NEGATIVE:
      case LabelId.DONE:
        return 'Uwagi końcowe' // "Final remarks"
      case LabelId.CLOSE:
        return 'Zakończenie obsługi' // "End of service"
      default: {
        // Return default label description
        const label = Labels.get(labelId)
        return label ? label.title : `Label ${labelId}`
      }
    }
  }

  static descriptionForPatrol(labelId) {
    switch (labelId) {
      case LabelId.NEW:
        return 'Powiadomienie patrolu' // "Patrol notified"
      case LabelId.DELIVERED:
        return 'Powiadomienie odebrane' // "Notification received"
      case LabelId.POSITIVE:
      case LabelId.NEGATIVE:
      case LabelId.DONE:
        return 'Opis sytuacji' // "Description of the situation"
      case LabelId.CANCELED:
        return 'Odwołanie patrolu' // "Patrol canceled"
      case LabelId.CLOSE:
        return 'Odjazd' // "Departure"
      default: {
        // Return default label description
        const label = Labels.get(labelId)
        return label ? label.title : `Label ${labelId}`
      }
    }
  }

  static descriptionForService(labelId) {
    switch (labelId) {
      case LabelId.NEW:
      case LabelId.AT_LOCATION:
        return 'Rozpoczęcie serwisu'
      case LabelId.DELIVERED:
      case LabelId.READ:
        return 'Powiadomienie serwisu'
      case LabelId.POSITIVE:
        return 'Serwis wykonany'
      case LabelId.NEGATIVE:
        return 'Serwis niezakończony'
      case LabelId.DONE:
        return 'Serwis zakończony'
      case LabelId.CLOSE:
        return 'Zakończenie serwisu'
      case LabelId.CANCELED:
        return 'Odwołanie serwisu'
      default: {
        const label = Labels.get(labelId)
        return label ? label.title : `Label ${labelId}`
      }
    }
  }

  static descriptionInContext(labelId, taskType) {
    switch (taskType) {
      case UserTaskType.DISPATCHER:
        return Labels.descriptionForDispatcher(labelId)
      case UserTaskType.PATROL:
        return Labels.descriptionForPatrol(labelId)
      case UserTaskType.SERVICE:
        return Labels.descriptionForService(labelId)
      default: {
        // Fallback to default label description
        const label = Labels.get(labelId)
        return label ? label.title : `Label ${labelId}`
      }
    }
  }

  // Service-specific icons for final statuses (mirror report generator semantics):
  // DONE = finished without remarks, POSITIVE = performed (work done),
  // NEGATIVE = could not finish, CANCELED = service called off.
  static iconForService(labelId) {
    switch (labelId) {
      case LabelId.POSITIVE:
        return 'mdi-wrench'
      case LabelId.NEGATIVE:
        return 'mdi-wrench-clock'
      case LabelId.DONE:
        return 'mdi-check-circle-outline'
      case LabelId.CANCELED:
        return 'mdi-cancel'
      default: {
        const label = Labels.get(labelId)
        return label ? label.icon : 'mdi-circle'
      }
    }
  }
}

// Export convenience functions for backward compatibility
export function descriptionForDispatcher(labelId) {
  return Labels.descriptionForDispatcher(labelId)
}

export function descriptionForPatrol(labelId) {
  return Labels.descriptionForPatrol(labelId)
}

export function descriptionInContext(labelId, taskType) {
  return Labels.descriptionInContext(labelId, taskType)
}

export const ReasonsDict = [
  { type: LabelId.POSITIVE, text: 'Włamanie' },
  { type: LabelId.NEGATIVE, text: 'Alarm fałszywy' },
  { type: LabelId.NEGATIVE, text: 'Awaria systemu' },
  { type: LabelId.NEGATIVE, text: 'Błąd obsługi' },
  { type: LabelId.NEGATIVE, text: 'Błąd systemu' },
  { type: LabelId.NEGATIVE, text: 'Błąd użytkownika' },
  { type: LabelId.NEGATIVE, text: 'Inne' },
  { type: LabelId.NEGATIVE, text: 'Napad' },
  { type: LabelId.NEGATIVE, text: 'Osoby na terenie obiektu' },
  { type: LabelId.NEGATIVE, text: 'Otwarte okno' },
  { type: LabelId.NEGATIVE, text: 'Otwarte okno' },
  { type: LabelId.NEGATIVE, text: 'Prace serwisowe' },
  { type: LabelId.NEGATIVE, text: 'Przyczyna nieznana' },
  { type: LabelId.NEGATIVE, text: 'Próbny alarm' },
  { type: LabelId.NEGATIVE, text: 'Zwierze w obiekcie' },
  { type: LabelId.NEGATIVE, text: 'Zwierzęta w obiekcie' },
  { type: LabelId.DONE, text: 'Brak uwag' },
  { type: LabelId.POSITIVE, text: 'Agresywny klient' },
  { type: LabelId.POSITIVE, text: 'Kradzież' },
  { type: LabelId.POSITIVE, text: 'Obiekt zabezpieczony' },
  { type: LabelId.POSITIVE, text: 'Próba kradzieży' },
  { type: LabelId.POSITIVE, text: 'Próba włamania' },
]

/**
 * Maps a cost object to a cost display object with payment information
 * @param {Object} cost - cost object from task.details.cost
 * @param {Object} store - Vuex store instance for payments lookup
 * @returns {Object} - cost display object with name, icon, color, textColor
 */
export function mapCostToDisplay(cost, store) {
  const found = store.get('payments/findWithValue', cost.token)
  if (found) {
    return {
      name: found.short,
      icon: 'mdi-currency-usd',
      color: found.color,
      textColor: found.textColor,
    }
  } else {
    return {
      name: cost.name,
      icon: 'mdi-currency-usd',
      color: 'blue',
      textColor: 'white',
    }
  }
}

/**
 * Gets cost display object for a task if it has a cost
 * @param {Object} task - task object with details.cost
 * @param {Object} store - Vuex store instance for payments lookup
 * @returns {Object|null} - cost display object or null if task has no cost
 */
export function getTaskCost(task, store) {
  if (!task || !task.details || !task.details.cost) {
    return null
  }
  return mapCostToDisplay(task.details.cost, store)
}

export function getNotifiedUsers(task) {
  return task?.details?.notified ?? []
}
